import TeamMessageForm from './TeamMessageForm';

export default TeamMessageForm;
